import { FC } from 'react';

import { Icon, MenuIconWrapper, Title } from './MenuIcon.styled';

export type MenuIconProps = {
  icon: string;
  title: string;
  onClick?: () => void;
};

export const MenuIcon: FC<MenuIconProps> = ({
  icon,
  title,
  onClick,
}) => (
  <MenuIconWrapper data-testid="menu-icon" onClick={onClick}>
    <Icon src={icon} alt="menu-icon" />
    <Title>{title}</Title>
  </MenuIconWrapper>
);
